import { useProfile } from '@/hooks/useProfile';
import { useSubscription } from '@/hooks/useSubscription';
import { Link } from 'react-router-dom';
import { Label } from '@/components/ui/label';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Bell, CreditCard } from 'lucide-react';
import { Switch } from '@/components/ui/switch';
import { Separator } from '@/components/ui/separator';

export function NotificationSettings() {
  const { profile, isLoading, updateProfile } = useProfile();
  const { isPremium } = useSubscription();

  const handleFocoToggle = (checked: boolean) => {
    updateProfile.mutate({ foco_alerts_enabled: checked });
  };

  const handleDebtToggle = (checked: boolean) => {
    updateProfile.mutate({ debt_reminders_enabled: checked });
  };

  if (isLoading) {
    return <div className="text-muted-foreground">Cargando...</div>;
  }

  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <Bell className="h-5 w-5" />
          Notificaciones
        </CardTitle>
        <CardDescription>
          Configura las alertas por correo electrónico
          {!isPremium && ' — disponible con Premium'}
        </CardDescription>
      </CardHeader>
      <CardContent className="space-y-4">
        {!isPremium && (
          <p className="text-sm text-muted-foreground">
            <Link to="/upgrade" className="text-primary underline">
              Actualiza a Premium
            </Link>{' '}
            para activar notificaciones por email.
          </p>
        )}
        <div className="flex items-center justify-between">
          <div className="space-y-0.5">
            <Label htmlFor="foco-alerts" className="flex items-center gap-2">
              <Bell className="h-4 w-4 text-muted-foreground" />
              Alertas FOCO Score
            </Label>
            <p className="text-sm text-muted-foreground">
              Recibe un email cuando tu puntaje baje de 40
            </p>
          </div>
          <Switch
            id="foco-alerts"
            checked={profile?.foco_alerts_enabled ?? true}
            onCheckedChange={handleFocoToggle}
            disabled={!isPremium || updateProfile.isPending}
          />
        </div>
        
        <Separator />
        
        <div className="flex items-center justify-between">
          <div className="space-y-0.5">
            <Label htmlFor="debt-reminders" className="flex items-center gap-2">
              <CreditCard className="h-4 w-4 text-muted-foreground" />
              Recordatorios de Deudas
            </Label>
            <p className="text-sm text-muted-foreground">
              Recibe recordatorios antes de la fecha de pago
            </p>
          </div>
          <Switch
            id="debt-reminders"
            checked={profile?.debt_reminders_enabled ?? true}
            onCheckedChange={handleDebtToggle}
            disabled={!isPremium || updateProfile.isPending}
          />
        </div>
      </CardContent>
    </Card>
  );
}
